module.exports = __webpack_public_path__ + "static/media/wizualizacja-138.6bfcd529.png";